import type { MessagingSendMessage201AllOf } from './messagingSendMessage201AllOf';
import type { MessagingSendMessage201AllOfOnezero } from './messagingSendMessage201AllOfOnezero';

export type MessagingSendMessage201 = MessagingSendMessage201AllOf & MessagingSendMessage201AllOfOnezero;
